module.exports = __webpack_public_path__ + "static/media/watermelon-nutritionals.4d84c35f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/products/nutrition-facts/watermelon-nutritionals.png
// module id = 189
// module chunks = 0